import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ReportService } from '../../_services';
import {  Supplier, Report, LoginUser, Role, CostCenter } from '../../_models';
import { GlobalDataService } from '../../_shared';
import * as XLSX from 'xlsx'; 
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
@Component({
  standalone: false,
  selector: 'app-opex-accrual-report',
  templateUrl: './opex-accrual-report.component.html',
  styleUrls: ['./opex-accrual-report.component.css']
})
export class OpexAccrualReportComponent implements OnInit {
  OpexAccrualResult: any[] = [];
  ObjectKeys = Object.keys;
  suppliersResult: Supplier[] = [];
 // objectAccountsResult : Account[];
  objectAccountsResult: string[] = [];
  getMonths: string[] = [];
  getYrs : string[]=[];
  Area!: string | null;
  Department!: string | null;
  rptData = new Report();
   SupplierAB!: string | null;
   ObjectAccount = '';  
   Year = '';
  arrayList: Array<string> = [];
  config: any;
  ApprDt!: { year: number; month: number; day: number; };
  user: LoginUser = new LoginUser;
  CostCentersResult: CostCenter[] = [];
  arrayListArea: Array<string> = [];
  arrayListDepartment: Array<string> = [];
  arrayListAreaDistinct: Array<string> = [];
  arrayListDepartmentDistinct: Array<string> = [];
  @ViewChild('TABLE', { static: false })
  TABLE!: ElementRef;  
  
  constructor(
    private reportService  : ReportService,
    private gd : GlobalDataService,
  ) { }

  ngOnInit() {
    this.user = this.gd.getUserData();
    this.GetApprovedDate();
    this.getCenterData();
    this.getSuppliers();
    this.getObjectAccount();
    this.getAcurlYr();
    this.config = {
      itemsPerPage: 10,
      currentPage: 1,
      totalItems: this.OpexAccrualResult.length
    };
  }
  
  GetApprovedDate(){
    this.reportService.getApprovedDate().subscribe(res => {
      if(res!=null)
      {
        this.ApprDt = {
          "year": new Date(res.ApproveDate).getFullYear(),
          "month":  new Date(res.ApproveDate).getMonth()+1,
          "day": new Date(res.ApproveDate).getDate()
        }
      }
    });
  }

  getCenterData()
  {
    this.CostCentersResult= this.gd.getCostCenterData();
    this.arrayListArea = this.CostCentersResult.map(cost => cost.Area_CODE +"-" +cost.Area_description); 
    this.arrayListDepartment = this.CostCentersResult.map(cost =>cost.Division); 
    this.arrayListAreaDistinct = this.arrayListArea.filter((n, i) => this.arrayListArea.indexOf(n) === i);
    this.arrayListDepartmentDistinct = this.arrayListDepartment.filter((n, i) => this.arrayListDepartment.indexOf(n) === i);
  }
  searchArea = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.arrayListAreaDistinct.filter(v => v!=null && v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )

  searchDepartment = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.arrayListDepartmentDistinct.filter(v => v!=null && v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )

  getSuppliers()
  {
    this.suppliersResult= this.gd.getSupplierData();
    this.arrayList = this.suppliersResult.map(sup => sup.SupplierAB.toString().trim() +"-" +sup.SupplierName.toString().trim()); 

   
  }

  searchSupplier = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.arrayList.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )
  
  getObjectAccount()
  {
   
    this.objectAccountsResult=this.gd.getAccountData();
  }

  searchObjectAcnt = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.objectAccountsResult.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )

  getAcurlYr()
  {
    
    for (var i = 0; i <= 20; i++) {
      this.getYrs.push(((new Date().getFullYear()) - i).toString());
    }
  }

  search(){
    this.rptData.supplierAB=(this.SupplierAB==null || this.SupplierAB.trim()=='')?0: parseInt(this.SupplierAB.split('-')[0]);
    this.rptData.objectAccount=this.ObjectAccount.split('-')[0];
    this.rptData.area=(this.Area==null||this.Area=='')? null:this.Area.split('-')[0];
    this.rptData.department=(this.Department==null||this.Department=='')?null:this.Department;
    this.rptData.year=this.Year;
    this.rptData.ApprDate=this.gd.convertToStandardDate(this.ApprDt);
    this.rptData.ProvisionalId = this.user.Role ==Role.Admin||this.user.Role ==Role.ReadOnly ?"":this.user.ProvisioningID;
    this.reportService.getOpexAccrual(this.rptData).subscribe(data=>{
      this.OpexAccrualResult = data;
      if(data != null)
      {
      this.config = {
        itemsPerPage: 10,
        currentPage: 1,
        totalItems: this.OpexAccrualResult.length
      };
    }
    });
  }

  objectKey(obj: {}) {
    return Object.keys(obj);
  }

  formatedCerts() {
    if(this.OpexAccrualResult !=null){
      return this.OpexAccrualResult.reduce((prev, now) => {
        if (!prev[now.ObjectAccount]) {
          prev[now.ObjectAccount] = [];
        }

        prev[now.ObjectAccount].push(now);
        return prev;
      }, {});
    }
     

    

  }

  ExportTOExcel() {  
   
      var reportGrid = document.getElementById("reportGrid_all");
      var wb: XLSX.WorkBook = XLSX.utils.book_new();
      let ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(reportGrid);
      wb.SheetNames.push("Sheet1");
      wb.Sheets["Sheet1"] = ws;
  
      /* save to file */
      XLSX.writeFile(wb, 'OpexAccrual' + new Date().toDateString() + '_' + new Date().getTime().toString() + '.xlsx');
  } 
  
  pageChanged(event: any){
    this.config.currentPage = event;
  }
}
